import { useGrowl } from "PFApp/use_growl";
import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import { Input } from "PFComponents/text/input";
import { ApiRoute } from "PFCore/utilities/routes";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./account_contacts.module.scss";

type AccountContactPageProps = {
  accountContact: {
    contact_info: string;
  };
};

export const AccountContactsPage = ({ accountContact }: AccountContactPageProps) => {
  const { t } = useTranslation(["translation", "admin"]);
  const growl = useGrowl();
  const [contact, setContact] = useState(accountContact.contact_info || "");

  const updateContactInfo = () => {
    //@ts-ignore
    $.ajax({
      url: ApiRoute("/api/admin/account_contacts"),
      api_version: 1,
      method: "PUT",
      data: { contact_info: contact }
    }).then(() => {
      growl({ message: t("admin:accountContacts.success") });
    });
  };

  return (
    <div className={css.wrapper}>
      <h1 className={css.header}>{t("admin:accountContacts.title")}</h1>
      <PageBox style={{ padding: 20 }}>
        <div className={css.lineWrapper}>
          <div className={css.left}>{t("admin:accountContacts.contactInformation")}</div>
          <div className={css.right}>
            <Input
              value={contact}
              onChange={setContact}
              style={{ height: 40, width: "75%", paddingLeft: 14, marginRight: 24, marginBottom: 10 }}
            />
            <Button
              text={t("admin:accountContacts.setDefault")}
              className={css.button}
              kind="danger"
              onClick={() => setContact(t("admin:siteNavPhone"))}
            />
          </div>
        </div>
        <div className={css.footer}>
          <Button onClick={updateContactInfo}>{t("translation:update")}</Button>
        </div>
      </PageBox>
    </div>
  );
};
